import { useQueryClient } from '@tanstack/react-query';
import { useIntl } from '@mfw/components';

import { acceptPrivacyPolicy } from '../../api/privacyPolicies.api';
import { useAuthContext, useSnackbar } from '../../context';
import { queryKeys } from '../../queryKeys';
import { useMutation } from '../base';
import messages from './messages';

export default function useAcceptPrivacyPolicy() {
  const queryClient = useQueryClient();
  const { formatMessage } = useIntl();
  const { enqueueSnackbar } = useSnackbar();
  const { refetchCurrentUser } = useAuthContext();
  const response = useMutation({
    mutationFn: () => acceptPrivacyPolicy(),
    onSuccess: async () => {
      await queryClient.removeQueries({
        exact: false,
        queryKey: queryKeys.privacyPolicies.fetchUnsignedPrivacyPolicy._def,
      });
      await refetchCurrentUser();
      enqueueSnackbar({
        message: formatMessage(messages.privacyPolicyAccepted),
        variant: 'success',
      });
    },
  });
  return {
    ...response,
    isLoading: response.status === 'pending',
  };
}
